import { PageContainer, Spinner } from 'component-library';

import { LoaderWrapper } from './styles';

export const AuthLoader = () => {
  return (
    <PageContainer>
      <LoaderWrapper>
        <Spinner size="xlarge" />
      </LoaderWrapper>
    </PageContainer>
  );
};
